import { SearchHitSearchProductEntity } from '@generated-client/backend';
import { Path } from '@trwl/shared/lib/router';
import { SEARCH, setDuration, setShow, PRODUCT_SUGGESTION } from '@trwl/store';
import { useUnit } from 'effector-react';
import { usePathname, useRouter } from 'next/navigation';
import React, { useCallback } from 'react';

import { Suggestion } from './Suggestion';

export const ProductsSuggestion = ({
  onItemClick,
}: {
  onItemClick?: (path: string) => void;
}) => {
  const [changeShow, changeDuration] = useUnit([setShow, setDuration]);
  const pathname = usePathname();
  const isSearchEmpty = useUnit(SEARCH.$isSearchEmpty);
  const [products] = useUnit([PRODUCT_SUGGESTION.$productsSuggestions]);
  const router = useRouter();

  const enableSplash = useCallback(() => {
    changeDuration(20000);
    changeShow(true);
  }, [changeShow, changeDuration]);

  const handleClick = useCallback(
    (item: SearchHitSearchProductEntity) => {
      const path = Path.PRODUCT + '/' + item.id;
      onItemClick?.(path);
      if (!pathname.endsWith(path)) {
        enableSplash();
        router.push(path);
      }
    },
    [onItemClick, pathname, enableSplash, router],
  );

  if (isSearchEmpty) return null;
  if (!products.length) return null;

  return (
    <div className={'w-full'}>
      <div>Товары</div>
      {products.map((item) => (
        <Suggestion
          key={'product_' + item.id}
          title={item.content?.title ?? ''}
          image={item.content?.logo}
          onClick={() => {
            handleClick(item);
          }}
        />
      ))}
    </div>
  );
};
